import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";

function Giscus(_ref) {
  var id = _ref.id,
      repo = _ref.repo,
      repoId = _ref.repoId,
      category = _ref.category,
      categoryId = _ref.categoryId,
      mapping = _ref.mapping,
      term = _ref.term,
      reactionsEnabled = _ref.reactionsEnabled,
      emitMetadata = _ref.emitMetadata,
      inputPosition = _ref.inputPosition,
      theme = _ref.theme,
      lang = _ref.lang,
      loading = _ref.loading;
  useEffect(function () {
    import("./giscus.es.js");
  }, []);
  return jsx("giscus-widget", {
    id: id,
    repo: repo,
    repoid: repoId,
    category: category,
    categoryid: categoryId,
    mapping: mapping,
    term: term,
    reactionsenabled: reactionsEnabled,
    emitmetadata: emitMetadata,
    inputposition: inputPosition,
    theme: theme,
    lang: lang,
    loading: loading
  });
}

export { Giscus as default };